import { Injectable, inject } from '@angular/core';
import {HttpHeaders} from '@angular/common/http';
import {StorageService} from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class HttpHeaderService {
  private storage = inject(StorageService);


  getHeaderOptions(): {headers: HttpHeaders} {
    const headers = new HttpHeaders({
      'Accept-Language': this.storage.getLanguage() === null ? 'nl' : this.storage.getLanguage(),
      'X-Accept-Language': this.storage.getLanguage() === null ? 'nl' : this.storage.getLanguage(),
      'Cache-Control': 'no-cache',
      'Cache-control': 'no-store',
      'Expires': '0',
      'Pragma': 'no-cache',
      'X-Source-App': 'FE-MYABVV',
      'X-Current-App': 'FE-MYABVV'});
    return {headers: headers};
  }
}
